import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '@iso/lib/helpers/rtl';

const ProductCategoryPageWrapper = styled.div`
  .PageContent {
    .OrderInfo {
      width: 100%;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-flow: row wrap;
      -ms-flex-flow: row wrap;
      flex-flow: row wrap;
      -webkit-align-items: baseline;
      -webkit-box-align: baseline;
      -ms-flex-align: baseline;
      align-items: baseline;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;

      .Title {
        font-size: 16px;
        font-weight: 500;
        color: ${palette('grey', 8)};
        margin: 0 0 20px;
        line-height: 1;
      }

      .LeftSideContent {
        .LeftSideContentInput {
          > div {
            &::before {
              background-color: #ececec;
            }
          }
        }
      }
    }

    .LeftSideContent {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-align-items: flex-start;
      -webkit-box-align: flex-start;
      -ms-flex-align: flex-start;
      align-items: flex-start;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
      &.LeftSideContentInput {
        > div {
          &::before {
            background-color: #ececec;
          }
        }
      }
    }

    .BillingInformation {
      width: 100%;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-flow: row wrap;
      -ms-flex-flow: row wrap;
      flex-flow: row wrap;
      -webkit-align-items: baseline;
      -webkit-box-align: baseline;
      -ms-flex-align: baseline;
      align-items: baseline;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin-top: 15px;
      margin-bottom: 15px;

      
      h3.Title, .ant-select-selector, .ant-input {
        font-size: 16px;
        font-weight: 500;
        color: ${palette('grey', 9)};
        margin: 5px 0 10px;
        line-height: 1;
        height: 35px !important;
        label {
          font-size: 19px;
          font-weight: 500;
          color: ${palette('grey', 9)};
          margin: 0 0 10px;
          line-height: 1;
        }
        > div {
          &::before {
            background-color: #ececec;
          }
        }
        input {
          font-size: 15px;
          color: ${palette('grey', 7)};
          font-weight: 400;
          display: block;
          margin-top: 10px;
        }
      }
    }
    .isoExampleWrapper {
      margin: 0
    }
  }
  .PageFooter {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;

    .saveBtn {
      background: ${palette('blue', 14)};
      margin: ${(props) =>
        props['data-rtl'] === 'rtl' ? '0 15px 0 0' : '0 0 0 15px'};
    }
  }
`;

const Fieldset = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Label = styled.label`
  font-size: 13px;
  color: ${palette('text', 1)};
  line-height: 1.5;
  font-weight: 500;
  padding: 0;
  margin: 0 0 8px;
`;

export { Fieldset, Label };
export default WithDirection(ProductCategoryPageWrapper);
